import { PageRequest } from '@/core/request/PageRequest';
import { DocumentTypeRate } from '../DocumentTypeRates/DocumentTypeRates.types';

export interface DocumentType {
  active: boolean;
  bankAccountId: number;
  creditCard: boolean;
  debitCard: boolean;
  description: string;
  fiscalDocument: boolean;
  fixedRate: boolean;
  id: number;
  initials: string;
  matrixId: number;
  notGenerateFinancial: boolean;
  payOnTime: boolean;
  percentRate: number;
  planAccountExpenseId: number;
  planAccountIncomeId: number;
  rates: DocumentTypeRate[];
  bankAccounts: string;
  isStoneDocument: boolean;
  paymentType?: DocumentTypePaymentType;
  includeBankAccountInPaymentInstallments?: boolean;
}

export interface DocumentTypeReduced {
  description: string;
  id: number;
  initials: string;
  bankAccountId?: number;
  notGenerateFinancial: boolean;
}

export interface ListDocumentTypesQuery extends PageRequest {
  description?: string;
  initials?: string;
  active?: boolean;
  isStoneDocument?: boolean;
  accreditorType?: DocumentTypeAccreditorType;
}

export interface ListDocumentTypesQueryReduced extends PageRequest {
  description?: string;
  initials?: string;
  active?: boolean;
  isFinancial?: boolean;
  isStoneDocument?: boolean;
}

export enum DocumentTypePaymentType {
  Debit = 'DEBIT',
  Credit = 'CREDIT',
}

export enum DocumentTypeAccreditorType {
  STONE = 'STONE',
  TEF_ELGIN = 'TEF_ELGIN',
}

export interface CreateDocumentTypeRequest {
  active: boolean;
  bankAccountId?: number;
  creditCard: boolean;
  debitCard: boolean;
  description: string;
  fiscalDocument: boolean;
  fixedRate?: boolean;
  initials: string;
  isStoneDocument?: boolean;
  notGenerateFinancial: boolean;
  payOnTime: boolean;
  percentRate?: number;
  planAccountExpenseId?: number;
  planAccountIncomeId?: number;
  paymentType?: DocumentTypePaymentType;
  includeBankAccountInPaymentInstallments?: boolean;
  isPurchaseDeletionNotAllowed?: boolean;
  accreditorType?: DocumentTypeAccreditorType;
}

export interface UpdateDocumentTypeRequest {
  id: number;
  active: boolean;
  bankAccountId: number;
  creditCard: boolean;
  debitCard: boolean;
  description: string;
  fiscalDocument: boolean;
  fixedRate: boolean;
  initials: string;
  notGenerateFinancial: boolean;
  payOnTime: boolean;
  percentRate: number;
  planAccountExpenseId: number;
  planAccountIncomeId: number;
  isStoneDocument?: boolean;
  paymentType?: DocumentTypePaymentType;
  includeBankAccountInPaymentInstallments?: boolean;
  isPurchaseDeletionNotAllowed?: boolean;
  accreditorType?: DocumentTypeAccreditorType;
}
